module.exports = __webpack_public_path__ + "img/头图_人工智能应用实践.094a4d6b.png";